import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const LoginRoute = () => {
  const { currentUser } = useContext(AuthContext);

  return currentUser ? <Navigate to="/dashboard" /> : <Outlet />;
};

export default LoginRoute;